module.exports = ".fixed-header{position:sticky;top:0}\n"